// extracted by mini-css-extract-plugin
export default {"withMargins":"src-views-analytics-components-AnalyticsSnapDropOffGraph-AnalyticsSnapDropOffGraph__withMargins--LV6b9"};